/**
 * --- External Imports ---
 */
import { useMemo } from "react";
import { SWRConfiguration, SWRResponse } from "swr";

/**
 * --- Internal Imports ---
 */
import { GetProcessVerificationDataByDocumentId, GetProcessVerificationDataByDocumentIdResponse } from "@/apis/dtos";
import useGet from "../apis/useGet";

/**
 * --- Hook ---
 */
const getData = (response?: SWRResponse<GetProcessVerificationDataByDocumentIdResponse, GetProcessVerificationDataByDocumentIdResponse>) => response?.data;
const getError = (response?: SWRResponse<GetProcessVerificationDataByDocumentIdResponse, GetProcessVerificationDataByDocumentIdResponse>) => (response?.error ?? response?.data)?.responseStatus;
const getAdditionalState = (_?: SWRResponse<GetProcessVerificationDataByDocumentIdResponse, GetProcessVerificationDataByDocumentIdResponse>) => ({});

const useGetProcessVerificationDataByDocumentId = (query?: Partial<GetProcessVerificationDataByDocumentId>, configuration?: SWRConfiguration) => {
    const request = useMemo(() => {
        if (!query?.documentId) {
            return undefined;
        }

        return () => {
            return new GetProcessVerificationDataByDocumentId(query);
        }
    }, [query]);

    return useGet(request, { getData, getError, getAdditionalState }, configuration);
}

export default useGetProcessVerificationDataByDocumentId;